module.exports = __webpack_public_path__ + "img/ai-4.3a9c1a8.png";